<template>
  <div style="height: 460px; width: 100%">
    <l-map
      ref="map"
      :zoom="currentZoom"
      :center="currentCenter"
      :options="mapOptions"
      @update:center="centerUpdate"
      @update:zoom="zoomUpdate"
    >
      <l-tile-layer :url="url" :attribution="attribution" />
      <l-marker
        v-for="address in mainSearchBarStore.listAddresses"
        :key="address.practitionerId"
        :lat-lng="address.latLng"
        @click="() => scrollTo(address.practitionerId)"
      >
        <l-tooltip
          :options="{
            permanent: false,
            interactive: true,
            sticky: true,
            direction: 'top',
          }"
        >
          <div class="d-flex flex-column ga-1">
            <p style="color: #004838 !important; font-weight: 800">
              {{ `${address.practitionerName}` }}
            </p>
            <p>
              {{ `${address.formattedAddress}` }}
            </p>
            <p>
              {{ `${address.disciplines.join(', ')}` }}
            </p>
          </div>
        </l-tooltip>
      </l-marker>
    </l-map>
  </div>
</template>

<script lang="ts" setup>
import 'leaflet/dist/leaflet.css'
import { latLng } from 'leaflet'
import { LMap, LTileLayer, LMarker, LTooltip } from '@vue-leaflet/vue-leaflet'
import { ref, onMounted } from 'vue'
import { useGeolocationStore } from '@/store/geolocation/geolocationStore'
import { useMainSearchBarStore } from '@/store/search-page/mainSearchBarStore'

const url = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
const attribution =
  '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'

const geolocationStore = useGeolocationStore()
const mainSearchBarStore = useMainSearchBarStore()

const currentZoom = ref(6)
const currentCenter = ref(
  latLng(geolocationStore.getLat() ?? 0, geolocationStore.getLon() ?? 0),
)

onMounted(async () => {
  if (!geolocationStore.getLat() || !geolocationStore.getLon()) {
    await geolocationStore.initLocationService()
    currentCenter.value = latLng(
      geolocationStore.getLat(),
      geolocationStore.getLon(),
    )
  }
})

geolocationStore.$subscribe((mutation, state) => {
  if (!geolocationStore.storedLocationIsEmpty) {
    currentCenter.value = latLng(
      state.storedLocation['coords'].latitude,
      state.storedLocation['coords'].longitude,
    )
  }
})

const scrollTo = async (id: string) => {
  const cardToScrollTo: HTMLElement = document.getElementById(id)
  window.scrollTo({
    top: cardToScrollTo.offsetTop - 70, // - for the height of the navbar
    left: cardToScrollTo.offsetLeft,
    behavior: 'smooth', // smooth scroll - like a smoothie
  })
}

const mapOptions = {
  zoomSnap: 0.5,
}

const zoomUpdate = zoom => {
  currentZoom.value = zoom
}
const centerUpdate = center => {
  currentCenter.value = center
}
</script>

<style>
.leaflet-attribution-flag {
  display: none !important;
}
.leaflet-container {
  border-radius: 8px;
}

.leaflet-tooltip {
  background: white;
  color: #616161;
  padding: 8px;
  border-radius: 6px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  min-width: 170px !important;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
  font-size: 10px;
  font-weight: 700;
}

.practitionner-name {
  color: #004838 !important;
}
</style>
